export class LocalStorageKey {
    static DashboardConfig = "dashboardConfig";
}